import React, { useEffect } from "react";
import { StickerPackInterface } from "../../../../store/sticker_maker/stickerPacksSlice";

import { Button, Form, Input, Radio, Select, Tag } from "antd";
import FileDropzone from "../../../../componets/FileDropzone";
import { useAppSelector } from "../../../../store/hooks";
import { selectCategoryEntities, selectCategoryIds } from "../../../../store/sticker_maker/categoriesSlice";
import { filterOptionByLabel } from "../../../../helpers/FormHelper";
import type { CustomTagProps } from 'rc-select/lib/BaseSelect';

interface propsInterface {
  params?: StickerPackInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const categories = useAppSelector(selectCategoryEntities);
  const categoryIds = useAppSelector(selectCategoryIds);
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  const options = categories && categoryIds ?
    categoryIds.map(id => ({ label: categories[id]?.name, value: categories[id]?.id })) :
    [];

  const tagRender = (props: CustomTagProps) => {
    const { label, value, closable, onClose } = props;
    const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
      event.preventDefault();
      event.stopPropagation();
    };
    const category = categories[value];

    return (
      <Tag
        color={category?.color || 'default'}
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        style={{ marginRight: 3 }}
      >
        {label}
      </Tag>
    );
  };

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <div className='v-group-dropzone'>
        <FileDropzone name='image' label='Image' preview={params?.image_url} />
      </div>

      <Form.Item label="Pro" name='pro'>
        <Radio.Group>
          <Radio value={0}>Free</Radio>
          <Radio value={1}>Premium</Radio>
          <Radio value={2}>Ads</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item
        name='category_ids'
        label="Select a tag"
      >
        <Select
          mode="multiple"
          allowClear
          showSearch
          filterOption={filterOptionByLabel}
          placeholder='Select a tag'
          tagRender={tagRender}
          options={options}
        />
      </Form.Item>

      <Form.Item name='name' label="Name">
        <Input placeholder='Name' />
      </Form.Item>

      <Form.Item name='keywords' label="Keywords">
        <Input.TextArea rows={4} />
      </Form.Item>

      <Form.Item name='search_text' label="Search Text">
        <Input.TextArea rows={3} />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
